import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import StarGroup from './StarGroup';
import { scaleW } from '@/common/style';
import { IComment, IVideoCoverType } from './types';
import { vIf } from '@/common/utils/vIf';
import Image from '@kds/image';
import { KTouchableOpacity } from '@/component/RtlLayout/Touchable';
import VideoOrImageCover from './VideoOrImageCover';

const style = StyleSheet.create({"container":{},"info":{"flexDirection":"row","justifyContent":"space-between","alignItems":"center"},"avatar":{"width":"6.76328502415459rem","height":"6.76328502415459rem","borderRadius":"3.381642512077295rem"},"username":{"marginHorizontal":"1.9323671497584543rem","color":"rgba(0, 0, 0, 0.88)","maxWidth":"31.40096618357488rem"},"specDesc":{"color":"#C2C2C2","fontSize":"2.8985507246376816rem"},"commentWrapper":{"flexDirection":"row","alignItems":"flex-end"},"comment":{"marginTop":"1.9323671497584543rem","color":"rgba(0, 0, 0, 0.88)","fontSize":"3.381642512077295rem","flexShrink":1,"lineHeight":"4.5893719806763285rem"},"transparentComment":{"color":"rgba(0, 0, 0, 0)"},"date":{"color":"#000","fontSize":"2.8985507246376816rem","height":"6.76328502415459rem","lineHeight":"6.76328502415459rem"},"image":{"width":"14.492753623188406rem","height":"14.492753623188406rem","borderRadius":"1.9323671497584543rem","marginLeft":"3.381642512077295rem","overflow":"hidden"}});

interface ICommentCardProps {
    showTime?: boolean;
    onClickImage?: (params: { index?: number; videoAndImgs: IVideoCoverType[] }) => void;
    onClick?: () => void;
}

const MAX_TEXT_LINES = 3;
const CommentCardMini = (props: IComment & ICommentCardProps) => {
    const videoAndImgs = (() => {
        const { videoList = [], imageUrl = [] } = props;
        const _videos = videoList?.map(i => ({
            isVideo: true,
            poster: i.videoCoverUrl,
            url: i.videoMainUrl,
        }));
        const _imgs = imageUrl?.map(i => ({
            isVideo: false,
            poster: '',
            url: i,
        }));
        return [..._videos, ..._imgs];
    })();
    // console.log(videoAndImgs, 'videoAndImgs::::');

    return (
        <KTouchableOpacity onPress={() => props.onClick && props.onClick()}>
            <View style={style.container}>
                <View style={style.info}>
                    <View
                        style={{"flexDirection":"row","alignItems":"center"}}>
                        <Image style={style.avatar} source={{ uri: props.userHeadUrl }} />
                        <Text numberOfLines={1} ellipsizeMode={'tail'} style={style.username}>
                            {props.userName}
                        </Text>
                    </View>
                    <View
                        style={{"marginRight":"-0.9661835748792271rem"}}>
                        <StarGroup yellowStarCount={props.productScore} />
                    </View>
                </View>

                <View
                    style={{"flexDirection":"row","justifyContent":"flex-start","alignItems":"flex-start","marginTop":"2.8985507246376816rem"}}>
                    <View style={{"flex":1}}>
                        <Text style={style.specDesc}>{props.skuSpecDesc}</Text>
                        {vIf(
                            Boolean(props.detail),
                            <View style={style.commentWrapper}>
                                <Text numberOfLines={2} style={style.comment}>
                                    {props.detail}
                                </Text>
                            </View>
                        )}
                    </View>

                    {vIf(
                        videoAndImgs?.length > 0,
                        <>
                            <KTouchableOpacity
                                activeOpacity={0.6}
                                onPress={() => {
                                    props.onClickImage({ index: 0, videoAndImgs });
                                }}>
                                <View style={style.image}>
                                    <VideoOrImageCover
                                        iconSize={18}
                                        url={videoAndImgs?.[0]?.url}
                                        poster={videoAndImgs?.[0]?.poster}
                                        isVideo={videoAndImgs?.[0]?.isVideo}
                                    />
                                </View>
                            </KTouchableOpacity>
                        </>
                    )}
                </View>
            </View>
        </KTouchableOpacity>
    );
};

export default CommentCardMini;
